import { ModelType } from '@/modules/core/app/constants/ModelType';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { DocumentExtraction } from '@/modules/ai/models/DocumentExtraction';
import { Opportunity } from '@/modules/opportunity/models/Opportunity';

export class ExtractedOpportunity extends BaseEntityModel {
  id?: number;
  documentExtractionId?: number;
  opportunityId?: number;
  documentExtraction?: Relationship<DocumentExtraction> | null;
  opportunity?: Relationship<Opportunity> | null;

  constructor(model: Partial<ExtractedOpportunity> = {}) {
    super(model);

    this.id = model.id;
    this.documentExtractionId = model.documentExtractionId;
    this.opportunityId = model.opportunityId;
    this.documentExtraction = DocumentExtraction.mapModelOrNull(model.documentExtraction);
    this.opportunity = Opportunity.mapModelOrNull(model.opportunity);
  }

  getModelName(): ModelType {
    return ModelType.EXTRACTED_OPPORTUNITY;
  }
}
